const Gallery = ({ data }) => {
  if (!data || !data.length) return null;
  const primaryImage = data[0];
  const [pWidth, pHeight] = primaryImage.size?.split("x") || [0, 0];
  let secondaryData;
  let sWidth = 0;
  let sHeight = 0;
  if (data.length === 2) {
    secondaryData = data[1];
    const dimensions = secondaryData.size?.split("x") || [0, 0];
    sWidth = dimensions[0];
    sHeight = dimensions[1];
  }

  return (
    <>
      <picture>
        <source srcSet={primaryImage.src_set} />
        <img
          className={`${
            secondaryData
              ? `opacity-100 
                group-hover:opacity-0 
                group-hover:h-0`
              : ""
          } h-auto w-full select-none 
          transition-[opacity,transform]
          duration-75 ease-in-out`}
          width={Number(pWidth)}
          height={Number(pHeight)}
          style={{ contentVisibility: "auto" }}
          src={primaryImage.src}
          alt={primaryImage.alt}
          loading={"lazy"}
          decoding="async"
        />
      </picture>

      {secondaryData ? (
        <div
          className="
          h-0 scale-0 opacity-0 
          select-none brightness-20
          group-hover:scale-100 
          group-hover:opacity-100
          group-hover:h-full
          group-hover:brightness-100

          transition-[opacity,transform]
          duration-100 ease-in-out
        "

        >

          {secondaryData.type === "VIDEO" ? (
            <>
              <div className="spinner" />
              <video
                loop
                muted
                playsInline
                preload="none"
                width={sWidth}
                height={sHeight}
                poster={secondaryData.thumbnail_url}
                className="h-auto w-full"
              >
                <source src={secondaryData.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </>
          ) : (
            <picture>
              <source srcSet={secondaryData.src_set} />
              <img
                width={Number(sWidth)}
                height={Number(sHeight)}
                style={{ contentVisibility: "auto" }}
                src={secondaryData.src}
                alt={secondaryData.alt}
                loading={"lazy"}
                decoding="async"
                className="h-full w-full"
              />
            </picture>
          )}

        </div>
      ) : null}
    </>
  );
};

export default Gallery;
